//==========================================================================
// account.js
//==========================================================================

function initAccountUI() {
  const $doc = $(document);

  // ------------------------------
  // Member Type Toggle
  // ------------------------------
  $doc.on('change', '.js-member-type', function () {
    const target = $(this).data('target');
    
    $('.js-form-content').hide();
    $('.js-form-content[data-form="' + target + '"]').show();
  });

  // ------------------------------
  // Custom dropdown
  // ------------------------------
  function closeAllDropdown(except) {
    $('.js-dd').not(except).removeClass('is-open')
      .find('.dd__btn').attr('aria-expanded', 'false');
  }

  $doc.on('click', '.js-dd .dd__btn', function (e) {
    e.preventDefault();
    const $dd = $(this).closest('.js-dd');
    const isOpen = $dd.hasClass('is-open');

    closeAllDropdown($dd);

    $dd.toggleClass('is-open', !isOpen);
    $(this).attr('aria-expanded', String(!isOpen));
  });

  $doc.on('click', '.js-dd .dd__opt', function (e) {
    e.preventDefault();
    const $opt = $(this);
    const $dd = $opt.closest('.js-dd');
    const val = $opt.data('value');
    const txt = $.trim($opt.text());

    $dd.find('.js-dd-val').text(txt);
    $dd.find('.js-dd-input').val(val);

    $dd.removeClass('is-open')
      .find('.dd__btn').attr('aria-expanded', 'false');
  });

  $doc.on('click', function (e) {
    const $t = $(e.target);
    if ($t.closest('.js-dd').length === 0) closeAllDropdown();
  });

  $doc.on('keydown', function (e) {
    if (e.key === 'Escape') closeAllDropdown();
  });

}

function initUploadFilename() {
  const $doc = $(document);
  $doc.on('change', '.js-file-upload', function () {
    const $input = $(this);
    const $filename = $input.closest('.bulk-drop').find('.js-filename');
    const files = this.files;

    if (files && files.length > 0) {
      const fileName = files[0].name;
      $filename.text(fileName).show();
    } else {
      $filename.hide();
    }
  });
}

function initOrderToggle() {
  $('.ship-card .js-order-toggle').each(function () {
    const $button = $(this);
    const $body = $button.closest('.ship-card').find('.js-order-body').hide();
    const $text = $button.find('.c-btn__text');
    const $card = $button.closest('.ship-card');

    $button.on('click', function () {
      const isOpen = $button.hasClass('is-open');
      
      $button.toggleClass('is-open');
      $text.text($button.hasClass('is-open') ? '閉じる' : 'もっと見る');
      
      if (isOpen) {
        const headerHeight = $('.l-header').outerHeight() || 0;
        const offset = 20;
        const scrollPosition = $card.offset().top - headerHeight - offset;
        
        $('html, body').animate({ scrollTop: scrollPosition }, 400);
      }
      
      $body.stop(true, true).slideToggle(400);
    });
  });
}

function initOrderListToggle() {
  $('.order-card').each(function() {
    const $card = $(this);
    const $items = $card.find('.order-item');

    if ($items.length > 2) {
      $items.slice(2).hide();
    }
  });

  $('.js-order-more').on('click', function () {
    const $btn = $(this);
    const $card = $btn.closest('.order-card');
    const $items = $card.find('.order-item');
    const $text = $btn.find('.c-btn__text');
    const isOpen = $btn.hasClass('is-open');

    $btn.toggleClass('is-open');
    $text.text(isOpen ? 'もっと見る' : '閉じる');
    $items.slice(2).stop(true, true).slideToggle(200);
  });
}

function initOrderDetailToggles() {
  if ($(window).width() >= 768) {
    $('.order-toggles').each(function() {
      const $panels = $(this).find('.js-order-panel');
      let maxHeight = 0;
      
      $panels.each(function() {
        const h = $(this).outerHeight();
        if (h > maxHeight) maxHeight = h;
      });
      
      $panels.css('min-height', maxHeight);
    });
  }

  $(document).on('click', '.order-toggle .js-order-toggle', function () {
    const $wrap = $(this).closest('.order-toggle');
    const $panel = $wrap.find('.js-order-panel');
    $wrap.toggleClass('is-open');
    $panel.prop('hidden', false).stop().slideToggle(300);
  });
}

function initCopyUrl() {
  $('.js-copy-url').on('click', function() {
    const tempInput = $('<input>').val($('.egift-card__url-input').val()).appendTo('body');
    tempInput[0].select();
    document.execCommand('copy');
    tempInput.remove();

    const $popup = $('<div class="copy-popup">コピーしました！！</div>').appendTo('body');
    setTimeout(() => $popup.addClass('show'), 10);
    setTimeout(() => {
      $popup.removeClass('show');
      setTimeout(() => $popup.remove(), 300);
    }, 1500);
  });
}

//------------------------------
$(function () {
  initAccountUI();
  initUploadFilename();
  initOrderToggle();
  initOrderListToggle();
  initOrderDetailToggles();
  initCopyUrl();
});
